import featureFlagConfig from './featureFlags.json';

const resolveRawEnv = () => {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env.VITE_UI_ENV || import.meta.env.MODE || 'development';
  }

  return process.env.NODE_ENV || 'development';
};

const normalizeEnvKey = (env) => {
  if (!env) return 'dev';

  const trimmed = env.toLowerCase();
  if (trimmed === 'prod' || trimmed === 'production') {
    return 'prod';
  }

  return 'dev';
};

const rawEnv = resolveRawEnv();
const envKey = normalizeEnvKey(rawEnv);
const fallbackKey = featureFlagConfig[envKey] ? envKey : 'dev';
const featureSet = featureFlagConfig[fallbackKey] || {};

export const isFeatureEnabled = (featureName) => {
  if (!(featureName in featureSet)) {
    console.warn(`Feature flag '${featureName}' not found`);
    return false;
  }

  return Boolean(featureSet[featureName]);
};

export const getFeatureFlag = (featureName) => {
  return featureSet[featureName];
};

export const getAllFeatureFlags = () => {
  return { ...featureSet };
};

export const getUIEnvironment = () => {
  return fallbackKey === 'prod' ? 'production' : 'development';
};

export default {
  isFeatureEnabled,
  getFeatureFlag,
  getAllFeatureFlags,
  getUIEnvironment
};
